const baseUrl = process.env.REACT_APP_baseUrl;
const referralUrl=process.env.REACT_APP_REFERRALURL
const socketUrl=process.env.REACT_APP_SOCKETURL
const binanceSocket=process.env.REACT_APP_WEBSOCKETURL
export { baseUrl,referralUrl,socketUrl,binanceSocket };